@if (this.forms && this.forms.length) {
  <div class="pinned">
    <h1 class="title">{{ 'addprojects' | translate }}</h1>
    <div class="buttons">
      <button nbButton [shape]="'semi-round'"  [size]="'small'" [status]="'basic'" [routerLink]="'/projects'">{{ 'cancel' | translate }}</button>
    </div>
  </div>
  <article class="card-like no-right-padding">
    <nb-stepper orientation="vertical" #stepper>
      <nb-step [stepControl]="this.forms[0].form" [label]="'projectname' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{ 'projectcalled' | translate }}</h2>
          <form [formGroup]="this.forms[0].form" class="step-container">
            <div class="input-group">
              <input nbInput fullWidth required [fieldSize]="'large'" type="text" maxLength="100" nbAutofocus [placeholder]="'enterprojectname' | translate" formControlName="name">
              <div class="client-row">
                <bst-list-adder target="client" [placeholder]="'enterclientname' | translate" [addnew]="addnew" [size]="'large'" [single]="true" size="small" formControlName="for_Client_id"></bst-list-adder>
              </div>
            </div>
            <div class="input-extra">
              <button nbButton size="small" type="button" status="basic" (click)="this.forms[0].toggle()">{{ (this.forms[0].isshown ? 'lessoptions' : 'moreoptions') | translate }}</button>
              @if (this.forms[0].isshown) {
                <div class="input-group">
                  <ul class="field-list">
                    <li>
                      <label><nb-icon [icon]="'activity'"></nb-icon><span>{{ 'status' | translate }}</span></label>
                      <nb-radio-group formControlName="status">
                        <nb-radio [value]="1">{{ 'userstatus.1' | translate }}</nb-radio>
                        <nb-radio [value]="2">{{ 'userstatus.2' | translate }}</nb-radio>
                      </nb-radio-group>
                    </li>
                    <li>
                      <label><nb-icon [icon]="'color-palette-outline'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.color' | translate" [attr.aria-description]="'explain.project.color' | translate">{{ 'color' | translate }}</span></label>
                      <input nbInput type="color" fieldSize="small" formControlName="color" [placeholder]="'color' | translate">
                    </li>
                    <li>
                      <label><nb-icon [icon]="'info-outline'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.description' | translate" [attr.aria-description]="'explain.project.description' | translate">{{ 'description' | translate }}</span></label>
                      <textarea nbInput [placeholder]="'enterprojectdescription' | translate" maxlength="30000" formControlName="description"></textarea>
                    </li>
                  </ul>
                </div>
              }
            </div>
            <button nbButton [bstErroring]="this.forms[0].form" (bstErroringSuccess)="stepper.next()" type="button" status="primary">{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[1].form" [label]="'projecttimeline' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{ 'projectwhen' | translate }}</h2>
          <form [formGroup]="this.forms[1].form" class="step-container">
            <div class="input-group">
              <input nbInput [fieldSize]="'large'" nbAutofocus [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" formControlName="dates">
              <nb-rangepicker #rangepicker></nb-rangepicker>
            </div>
<!--            <div class="input-extra">-->
<!--              <button nbButton type="button" size="small" status="control" (click)="this.forms[1].toggle()">{{ (this.forms[1].isshown ? 'lessoptions' : 'moreoptions') | translate }}</button>-->
<!--              <div *ngIf="this.forms[1].isshown" class="input-group">-->
<!--                <ul class="field-list">-->
<!--                  <li>-->
<!--                    <label><nb-icon [icon]="'checkmark-square'"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'explain.project.due_on' | translate" [attr.aria-description]="'explain.project.due_on' | translate">{{ 'due' | translate }}</span></label>-->
<!--                    <input nbInput [placeholder]="'enterduedate' | translate" [nbDatepicker]="datepicker" formControlName="duedate">-->
<!--                    <nb-datepicker #datepicker></nb-datepicker>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[1].form" (bstErroringSuccess)="stepper.next()" status="primary" type="button" >{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[2].form" [label]="'projectindustry' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{'projectwhatindustry' | translate }}</h2>
          <form [formGroup]="this.forms[2].form" class="step-container">
            <div class="input-group">
              <bst-list-adder size="large" [autolist]="true" target="industry" formControlName="industry"></bst-list-adder>
            </div>
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[2].form" (bstErroringSuccess)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[3].form" [label]="'hardskills' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{'projectwhatskills' | translate }}</h2>
          <form [formGroup]="this.forms[3].form" class="step-container">
            <div class="input-group">
              <bst-list-adder size="large" [autolist]="true" target="skill" [placeholder]="'search?' | translate" formControlName="skills"></bst-list-adder>
            </div>
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[3].form" (bstErroringSuccess)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[4].form" [label]="'softskills' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{'projectwhatsoftskills' | translate }}</h2>
          <form [formGroup]="this.forms[4].form" class="step-container">
            <div class="input-group">
              <bst-list-adder size="large" [autolist]="true" target="development" [placeholder]="'search?' | translate" formControlName="developments"></bst-list-adder>
            </div>
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[4].form" (bstErroringSuccess)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[5].form" [label]="'certifications' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{'projectwhatcertifications' | translate }}</h2>
          <form [formGroup]="this.forms[5].form" class="step-container">
            <div class="input-group">
              <bst-list-adder size="large" [autolist]="true" target="certification" [placeholder]="'search?' | translate" formControlName="certifications"></bst-list-adder>
            </div>
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[5].form" (bstErroringSuccess)="stepper.next()" status="primary" type="button">{{ 'next' | translate }}<nb-icon [icon]="'chevron-right'"></nb-icon></button>
          </form>
        </div>
      </nb-step>
      <nb-step [stepControl]="this.forms[6].form" [label]="'projectpositions' | translate">
        <div class="step-wrapper" (scroll)="scroll.fireScrollChange($event)">
          <h2>{{ 'projectwhatpositions' | translate }}</h2>
          <form [formGroup]="this.forms[6].form" class="step-container">
            <div class="input-group">
              <bst-user-project-assigner [project]="null" [projectroles]="projectroles" [range]="range" formControlName="assignments"></bst-user-project-assigner>
            </div>
            <button nbButton nbStepperPrevious type="button"><nb-icon [icon]="'chevron-left'"></nb-icon>{{ 'previous' | translate }}</button>
            <button nbButton [bstErroring]="this.forms[6].form" (bstErroringSuccess)="submit()" status="primary" type="button"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
          </form>
        </div>
      </nb-step>
    </nb-stepper>
  </article>
}
